import { Link } from "react-router-dom";
import { BrandButton } from "../BrandButton";
import { Reveal } from "../anim";
import { LEARN_GUIDES } from "../../content/learnGuides";

export function GuideDepth({ depth }) {
  return (
    <section className="surface-night with-bloom py-20 lg:py-28" data-testid="guide-depth">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal>
          <div className="lg-depth grid gap-8 lg:grid-cols-12 items-center">
            <div className="lg:col-span-8">
              <p className="lg-eb text-champagne">{depth.label}</p>
              <h2 className="trex-h2 text-bone mt-5 leading-[1.1]">{depth.title}</h2>
              <p className="mt-5 text-base lg:text-lg text-bone/70 leading-relaxed max-w-2xl">{depth.body}</p>
            </div>
            <div className="lg:col-span-4 lg:justify-self-end">
              <BrandButton to={depth.to} tone="night" data-testid="guide-depth-cta">{depth.cta}</BrandButton>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function GuideNextDoors({ currentSlug }) {
  const others = LEARN_GUIDES.filter((g) => g.slug !== currentSlug);
  return (
    <section className="surface-day py-20 lg:py-28" data-testid="guide-next-doors">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal>
          <h2 className="trex-h2 text-aubergine leading-[1.05] mb-10">The other <em className="accent-italic">doors</em>.</h2>
        </Reveal>
        <div className="grid gap-4 sm:grid-cols-3">
          {others.map((g, i) => (
            <Reveal key={g.slug} delay={i * 90} className="h-full">
              <Link to={`/learn/${g.slug}`} className="lg-door h-full" data-testid={`guide-door-${g.slug}`}>
                <span className="font-mono text-[11px] tracking-[0.18em] text-champagne">{g.num}</span>
                <h3 className="lg-door-name">{g.name}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-aubergine/70 flex-1">{g.dek}</p>
                <span className="lg-door-cta">Read the orientation <span aria-hidden="true">→</span></span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
